<template>
	<div class="auth-main" :class="[this.$config.domain.ename]">
		<el-form ref="loginForm" :model="loginData" :rules="rules" v-if="isHidden">
			<el-form-item class="input-item" prop="account">
				<el-input
					class="login-input"
					v-model="loginData.account"
					placeholder="手机号"
					prefix-icon="iconfont el-icon-user"
				></el-input>
			</el-form-item>
			<el-form-item class="input-item" prop="password">
				<el-input
					class="login-input"
					type="password"
					v-model="loginData.password"
					placeholder="密码"
					prefix-icon="iconfont icon-lock"
				></el-input>
			</el-form-item>
			<el-form-item
				class="input-item"
				style="margin-bottom: 5px !important; margin-top: -12px"
			>
				<CaptchaVerify
					ref="CaptchaVerify"
					@verify="verifySuccess"
				></CaptchaVerify>
			</el-form-item>
			<el-form-item
				><CommonButton
					:buttonTitle="pwdTiltle"
					:isDisable="pwdIsDisable"
					class="login-button"
					:type="'primary'"
					@buttonClick="handlerLogin"
			/></el-form-item>
			<div class="login-way-row">
				<el-button type="text" class="login-way" @click="loginAccount"
					>短信验证码登录</el-button
				>
				<div class="register-row">
					<span class="register-text">没有账号？</span>
					<el-button
						type="text"
						class="login-way register-link"
						@click="goRegister"
						>立即注册</el-button
					>
				</div>
			</div>
		</el-form>

		<el-form ref="loginFormTel" :model="telLoginData" :rules="rulesTel" v-else>
			<el-form-item class="input-item" prop="telephone">
				<el-input
					placeholder="请输入手机号"
					type="text"
					class="login-input"
					v-model="telLoginData.telephone"
				>
					<template slot="prepend">
						+86
					</template>
				</el-input>
			</el-form-item>
			<el-form-item class="input-item" prop="registerCode">
				<el-input
					placeholder="短信验证码"
					type="text"
					class="login-input"
					v-model="telLoginData.registerCode"
				>
					<template slot="append">
						<div>
							<el-button
								class="get-register"
								:disabled="!telLoginData.telephone || phoneCode != '获取验证码'"
								@click="getVerifiCode"
								>{{ phoneCode }}</el-button
							>
						</div>
					</template>
				</el-input>
			</el-form-item>
			<el-form-item
				class="input-item"
				style="margin-bottom: 5px !important; margin-top: -12px"
			>
				<CaptchaVerify
					ref="CaptchaVerify"
					@verify="verifySuccess"
				></CaptchaVerify>
			</el-form-item>
			<el-form-item
				><CommonButton
					:buttonTitle="pwdTiltle"
					:isDisable="telLogin"
					class="login-button"
					:type="'primary'"
					@buttonClick="handlerLogin"
			/></el-form-item>
			<div class="login-way-row">
				<el-button
				v-if="isShowAccountLogin"
				type="text"
				class="login-way"
				@click="loginTel"
				>用户名密码登录</el-button
			>
			<div class="register-row">
				<span class="register-text">没有账号？</span>
				<el-button
					type="text"
					class="login-way register-link"
					@click="goRegister"
					>立即注册</el-button
				>
			</div>
			</div>
		</el-form>
	</div>
</template>

<script>
import { mapMutations } from "vuex";
import CommonButton from "@/components/CommonButton";
import config from "@/config/config.js";
import { ZYE_NAME } from "@/config/const_name.js";
import SmartCaptcha from "../../components/captchas/SmartCaptcha";
import SlideCaptcha from "../../components/captchas/SlideCaptcha";
import CaptchaVerify from "../../components/CaptchaVerify";
export default {
	components: {
		CommonButton,
		SmartCaptcha,
		SlideCaptcha,
		CaptchaVerify,
	},
	data() {
		return {
			verify: {},
			isShowAccountLogin: true,
			phoneCode: "获取验证码",
			timer: null,
			//  默认是 密码登录，当点击获取验证码，滑动验证通过后，修改为 短信登录， 点击登录按钮时判断 loginType,发送不同的数据请求
			loginType: "password", // password, sms
			slideScene: "nc_message", //  滑动验证的 scene
			smartScene: "ic_login", //  智能验证的 scene

			Verified: "",
			title: "",
			pwdIsDisable: false,
			telIsDisable: false,
			telLogin: false,
			pwdTiltle: "登录",
			wait: 0,
			activeName: "login1",
			isVisible: false,
			isHidden: true,
			mobile: "18940981399",
			codeText: "获取验证码",
			loginData: {
				account: "",
				password: "",
				authenticate: "",
				token: "",
			},
			//手机登录数据
			telLoginData: {
				telephone: "",
				registerCode: "",
			},
			//手机号登录表单验证
			rulesTel: {
				telephone: [
					{ required: true, message: "输入手机号", trigger: "blur" },
					{ max: 11, message: "请输入11位手机号" },
				],
				registerCode: [
					{ required: true, message: "输入短信验证码", trigger: "blur" },
				],
			},
			// 表单验证
			rules: {
				account: [{ required: true, message: "输入手机号", trigger: "blur" }],
				password: [{ required: true, message: "输入密码", trigger: "blur" }],
			},
			is_zhengye: false,
		};
	},
	methods: {
		...mapMutations(["handleUserInfo"]),
		smsCountDown() {
			let count = 60;
			this.timer = setInterval(() => {
				if (count > 0 && count <= 60) {
					count--;
					this.phoneCode = `${count}秒重新发送`;
				} else {
					clearInterval(this.timer);
					this.timer = null;
					this.phoneCode = "获取验证码";
				}
			}, 1000);
		},
		async slideVerify(value) {
			if (value) {
				this.telLoginData.sessionId = this.verify.captchaVerifyParam;
				try {
					let result = await this.$api.getLoginCode({
						mobile: this.telLoginData.telephone,
						captchaVerifyParam: this.verify.captchaVerifyParam,
					});
					if (result) {
						this.$message.success("验证码发送成功");
						this.smsCountDown();
					}
				} catch (err) {
					this.telLoginData.sessionId = null;
				}
			} else {
				this.telLoginData.sessionId = null;
			}
		},
		verifySuccess(verify) {
			this.verify = verify;
			if (verify.popupId == "code") {
				this.slideVerify(true);
			}
		},
		handlerLogin() {
			if (this.loginType === "password") {
				console.log("账号密码登录");
				this.accountLogin();
			} else {
				console.log("短信验证码登录");
				this.smsLogin();
			}
		},
		//  账号、密码登录
		accountLogin() {
			this.$refs["loginForm"].validate(async (valid) => {
				if (valid) {
					if (this.verify.captchaResult) {
						try {
							const userInfo = await this.$api.submitLoginInfo({
								account: this.loginData.account,
								password: this.loginData.password,
								captchaVerifyParam: this.verify.captchaVerifyParam,
							});
							if (userInfo) {
								this.loginData = {};
								this.mxInitSwitch();
								this.handleUserInfo(userInfo);
								let obj = {};
								obj.id = userInfo.company_id;
								console.log("赋值两个ID-A");
								this.$storage.set("nowCompany", obj);
								this.$storage.set("settlementId", userInfo.settlement_id);

								const userInfos = await this.$api.getUserProfile();
								this.$storage.set(
									"is_yichen",
									userInfo.roles.includes("yichendaodi")
								);
								this.$storage.set("roles", userInfo.roles);
								this.$storage.set("user_info", userInfos);

								this.$message.success("登录成功");
								//this.$refs.smartCaptchaRef.reloadSmartCaptcha();
								console.log(userInfo, "用户信息2");
								this.go();
								console.log(userInfo, "用户信息3");
								if (userInfo.weak_password_info.weak_password) {
									this.$alert(userInfo.weak_password_info.message, "提醒", {
										confirmButtonText: "确定",
										callback: (action) => {
											console.log(
												action,
												userInfo.weak_password_info.message,
												userInfo.weak_password_info.remaining_days
											);
										},
									});
								}
							} else {
								this.$message.error("登录失败");
								//this.$refs.smartCaptchaRef.reloadSmartCaptcha();
								this.initRespErrMsgBoxMark();
								this.$refs.CaptchaVerify.clear();
							}
						} catch (error) {
							//this.$refs.smartCaptchaRef.reloadSmartCaptcha();
							this.$refs.CaptchaVerify.clear();
							this.loginData.sessionId = null;
							console.log("login error", error);
						}
					} else {
						this.$message.error("请先点击验证按钮开始验证");
					}
				} else {
					this.$message.error("登录失败，请检查必填项数据！");
				}
			});
		},
		//  短信验证码登录

		smsLogin() {
			this.telLogin = true;
			this.$refs["loginFormTel"].validate(async (valid) => {
				if (valid) {
					if (this.verify.captchaResult) {
						try {
							const userInfo = await this.$api.submitCodeLogin({
								mobile: this.telLoginData.telephone,
								code: this.telLoginData.registerCode,
								captchaVerifyParam: this.verify.captchaVerifyParam,
							});
							if (userInfo) {
								this.loginData = {};
								this.mxInitSwitch();
								this.handleUserInfo(userInfo);
								let obj = {};
								obj.id = userInfo.company_id;
								console.log("赋值两个ID-B");
								this.$storage.set("nowCompany", obj);
								this.$storage.set("settlementId", userInfo.settlement_id);

								const userInfos = await this.$api.getUserProfile();
								this.$storage.set(
									"is_yichen",
									userInfo.roles.includes("yichendaodi")
								);
								this.$storage.set("roles", userInfo.roles);
								this.$storage.set("user_info", userInfos);

								this.$message.success("登录成功");
								//this.$refs.smartCaptchaRef.reloadSmartCaptcha();
								this.go();
							} else {
								this.$message.error("登录失败");
								this.loginData.sessionId = null;
								//this.$refs.smartCaptchaRef.reloadSmartCaptcha();
								this.$refs.CaptchaVerify.clear();
								this.initRespErrMsgBoxMark();
							}
						} catch (error) {
							//this.$refs.smartCaptchaRef.reloadSmartCaptcha();
							this.$refs.CaptchaVerify.clear();
							this.loginData.sessionId = null;
							console.log("=========formSubmit", error);
						}
					} else {
						this.$message.error("请先点击验证按钮开始验证");
					}
				} else {
					this.$message.error("登录失败，请检查必填项数据！");
				}
			});
			this.telLogin = false;
		},

		async getVerifiCode() {
			this.$refs.CaptchaVerify.clear();
			if (!this.telLoginData.telephone) {
				this.$message.error("请先输入手机号");
			} else {
				this.loginType = "sms";
				this.$refs.CaptchaVerify.popup("code");
			}
		},
		//验证验证码
		async smsVerify() {
			let args = {
				mobile: this.telLoginData.telephone,
				code: this.telLoginData.registerCode,
			};
			if (this.telLoginData.sessionId) {
				try {
					let result = await this.$api.smsVerify(args);
					if (result) {
						await this.smsLogin();
					} else {
						this.telLoginData.sessionId = null;
					}
				} catch (err) {
					this.telLoginData.sessionId = null;
				}
			} else {
				this.$message.warning("请先完成验证");
			}
		},
		//  验证码页面的  登录按钮
		handlerSMSLogin() {
			this.$refs["loginFormTel"].validate((valid) => {
				if (valid) {
					console.log("ssss", this.telLoginData.sessionId);
					if (this.telLoginData.sessionId) {
						//  校对验证码是否正确
						this.smsVerify();
					} else {
						this.$message.warning("请先获取验证码");
					}
				} else {
					this.$message.error("登录失败，请检查必填项数据！");
				}
			});
		},
		//获取登录用户信息
		async getUserDetail(token) {
			this.$storage.set("jwt", token);
			this.$storage.set("jwtTime", Date.parse(new Date()));
			this.mxInitSwitch();
			let userinfo = await this.$api.getUserDetail();
			console.log("userinfo", userinfo);
			if (userinfo) {
				this.$storage.set("user_info", userinfo);
				this.handleUserInfo(userinfo);
			} else {
				this.$message.error("获取用户信息失败");
			}
		},
		//登录方式
		loginAccount() {
			this.isVisible = true;
			this.isHidden = false;
			this.loginType = "sms";
		},
		loginTel() {
			this.isVisible = false;
			this.isHidden = true;
			this.loginType = "password";
		},
		// 路由跳转
		go(url = "/home") {
			this.mxRedirect(url);
		},
		// 跳转注册
		goRegister() {
			this.$router.push("/register");
		},
		// 初始化响应错误弹窗标志
		initRespErrMsgBoxMark() {
			this.$store.commit("changeRespErrMsgBoxMark", false);
		},
	},
	mounted() {
		this.initRespErrMsgBoxMark();
		if (location.host == "ayg.jinzhangshi.com") {
			this.loginAccount();
			this.isShowAccountLogin = false;
		}
		//正晔（杭州）数字科技有限公司
		if (config.domain.ename === ZYE_NAME) {
			this.is_zhengye = true;
		}
	},
};
</script>

<style lang="stylus" scoped>
.auth-main
	margin 50px 50px 50px 50px
.input-item
	margin-bottom 32px !important
.el-checkbox
	color white !important
.login-input .el-input__inner
	height 50px
.el-tabs__nav-wrap::after
	height 0px
.el-tabs__nav
	display inline-block
	float none
.el-tabs__header
	text-align center
.el-input__prefix
	left 8px
.el-tabs__header
	margin-bottom 24px
.login-button
	width 100%
	height 50px
	margin-top 15px
	border none
.login-button:hover
	background #48B4FF
.el-checkbox, .el-checkbox, .el-checkbox__input.is-checked + .el-checkbox__label
	color #000000 !important
#tab-login2
	height 0px
.get-register
	width 120px
.el-form-item
	margin-bottom 5px
.el-form-item__conten
	height 50px
.login-way
	font-size 14px
	color #606266
.login-wrapper
	margin-top -25px
.remember
	color #757575
.password
	display flex
	flex-direction row
	justify-content space-between
	margin-top 30px
.register-row
	display flex
	align-items center
	justify-content flex-start
	flex-wrap nowrap
	gap 6px
.register-text
	color #606266
	font-size 14px
.register-link
	margin-left 0
	color #1890ff !important
>>> .nc_wrapper
	margin 0 auto
>>>.el-dialog__body
	padding-bottom 50px

.saaszhengyesoho .login-way{
	color: #C1272D ;
}
.saaszhengyesoho .d-login-btn{
	background-color: #C1272D;
}
.login-way-row {
	display: flex;
	align-items: center;
	justify-content: space-between;
	flex-wrap: nowrap;
	gap: 6px;
}
</style>
